// extracted by mini-css-extract-plugin
export default {"chek":"Cal_chek__Bji5O","frang":"Cal_frang__n-2s2","fcal":"Cal_fcal__SW9Mj","spann":"Cal_spann__tMLDv","Emi":"Cal_Emi__UGV8r","ran":"Cal_ran__kxEhz"};